import { render, staticRenderFns } from "./InvestmentVentures.vue?vue&type=template&id=f52683fc&scoped=true"
import script from "./InvestmentVentures.vue?vue&type=script&lang=js"
export * from "./InvestmentVentures.vue?vue&type=script&lang=js"
import style1 from "./InvestmentVentures.vue?vue&type=style&index=1&id=f52683fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f52683fc",
  null
  
)

export default component.exports